import { Fade, Paper } from '@mui/material';
import { validateEnum, withDefault } from '@weft/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { useTabParam } from '../../../hooks/use-tab-param';
import type { PageTab } from '../../../utils/types/page-tab';
import { GeneralTabContent } from './settings-page-components/GeneralTabContent/GeneralTabContent';
import { MembersTabContent } from './settings-page-components/MembersTabContent';
import type { SettingsPageTabOption } from './settings-page-types/settings-page-tab-option';
import { SETTINGS_PAGE_TAB_OPTIONS } from './settings-page-types/settings-page-tab-option';

const settingsPageTabs: Record<SettingsPageTabOption, PageTab<SettingsPageTabOption>> = {
  [SETTINGS_PAGE_TAB_OPTIONS.General]: {
    id: 0,
    render: <GeneralTabContent />,
    label: 'General',
    paramName: SETTINGS_PAGE_TAB_OPTIONS.General,
  },
  [SETTINGS_PAGE_TAB_OPTIONS.Members]: {
    id: 1,
    render: <MembersTabContent />,
    label: 'Members',
    paramName: SETTINGS_PAGE_TAB_OPTIONS.Members,
  },
};

const SettingsPage: React.FC = () => {
  const [tab, setTab] = useTabParam<SettingsPageTabOption>(SETTINGS_PAGE_TAB_OPTIONS.General, deserializeSettingsPageTabParam);
  const currentTab = withDefault(tab, SETTINGS_PAGE_TAB_OPTIONS.General);

  return (
    <>
      <Helmet>
        <title>Settings</title>
      </Helmet>

      <VyPageLayout
        title="Settings"
        path={[
          'Settings',
          currentTab[0].toUpperCase() + currentTab.slice(1),
        ]}
        currentTab={currentTab}
        tabs={[
          {
            label: 'Account',
            value: SETTINGS_PAGE_TAB_OPTIONS.General,
            onClick: () => setTab(SETTINGS_PAGE_TAB_OPTIONS.General),
          },
          {
            label: 'Members',
            value: SETTINGS_PAGE_TAB_OPTIONS.Members,
            onClick: () => setTab(SETTINGS_PAGE_TAB_OPTIONS.Members),
          },
        ]}
      >
        {Object.entries(settingsPageTabs).map(([settingsPageTab, { id, render }]) => (
          <Fade
            key={id}
            hidden={currentTab !== settingsPageTab}
            in={currentTab === settingsPageTab}
          >
            <div className="w-full">
              <Paper>
                {render}
              </Paper>
            </div>
          </Fade>
        ))}
      </VyPageLayout>
    </>
  );
};

export const SettingsPageWithGlobalSearchParams = withGlobalSearchParams(SettingsPage);
export { SettingsPageWithGlobalSearchParams as SettingsPage };

function deserializeSettingsPageTabParam(tab: string): SettingsPageTabOption | null {
  validateEnum(tab, SETTINGS_PAGE_TAB_OPTIONS);

  return tab;
}